//#region Libraries
import styled from "styled-components";
//#endregion

export const Container = styled.div`
    display: flex;
    flex-direction: column;
    min-width: 240px;
    gap: 10px;
    min-width: ${({ minWidth = "240px" }) => minWidth};
    width: ${({ width = "unset" }) => width};
    & label {
        font-weight: 600;
        font-size: 14px;
        transition: 0.35s;
    }
    @media (max-width: 690px) {
        width: 100%;
    }
`;
export const Content = styled.div`
    display: flex;
    align-items: center;
    gap: 10px;
    width: 100%;
    &.disabled label {
        color: var(--purple-4);
    }
`;
export const Subcontent = styled.div`
    display: flex;
    flex-direction: column;
    gap: 10px;
    width: 100%;
`;
export const CharCounter = styled.span` 
    font-size: 14px;
    &.error { color: var(--red-3); }
`;
export const ErrorText = styled.div`
    display: flex;
    align-items: center;
    gap: 5px;
    margin-left: 10px;
    & span {
        font-size: 14px;
        font-weight: 490;
    }
`;
export const ShowPassword = styled.span`
    display: block;
    align-self: center;
    margin-right: 8px;
    font-size: 12px;
    font-weight: bold;
    user-select: none;
    color: var(--purple-2);
    text-decoration: ${({ textDecoration }) => textDecoration || "unset"};
    cursor: pointer;
`;
export const ContainerTextInput = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
    gap: 5px;
    width: 100%;
    border-radius: 5px;
    border: 1px solid var(--border-color);
    --border-color: var(--light-gray-4);
    transition: 0.35s;
    & .icon {
        margin-right: 10px;
        display: grid;
        place-items: center;
        & svg, & path {
            fill: var(${({ focusInput }) => focusInput ? "--purple-2" : "--light-gray-5"});
        }
    }
    &, .primary {
        background-color: var(--light-1);
    }
    &.secondary {
        background-color: transparent;
    }
    &:hover {
        --border-color: var(--dark-3);
    }
    ${({ focusInput }) => focusInput 
        ? "--border-color: var(--purple-1) !important;" : ""}
    & > img {
        padding-right: 10px;
    }
    &.error {
        color: var(--red-2);
        --border-color: var(--red-2);
        & svg, & path {
            fill: var(--red-2);
        }
    }
    &.disabled {
        --border-color: var(--purple-4);
        & svg, & path {
            fill: var(--purple-4);
        }
    }
    & input::-ms-reveal {
        pointer-events: none;
        display: none;
    }
    & div[data-role="disabled-input"], & > input {
        padding: 10px 15px;
        background-color: transparent;
        color: var(--dark-4);
        caret-color: var(--purple-1);
        font-size: 14px;
        outline: none;
        border: 0;
        width: 100%;
        cursor: text;
        & span[data-role="text"], &::placeholder {
            word-break: break-word;
            color: var(--light-gray-4);
        }
    }
    &.error {
        & div[data-role="disabled-input"], & input::placeholder {
            color: var(--red-2);
        }
    }
    &.disabled {
        & div[data-role="disabled-input"], & input {
            color: var(--purple-4);
            & span[data-role="text"], &::placeholder {
                color: var(--purple-4);
            }
        }
    }
`;